module.exports = __webpack_public_path__ + "static/media/bg-deck-cards.74a4ac25.webp";